import { functions } from './firebase';

function wrapEhrServiceError(err, step) {
  const raw = err && typeof err === 'object' ? err : null;
  const message =
    raw && 'message' in raw && raw.message != null ? String(raw.message) : String(err || 'Unknown error');
  return new Error(`${step}: ${message}`);
}

export async function callEhrGetConnectionStatus(payload) {
  try {
    const fn = functions.httpsCallable('ehrGetConnectionStatus');
    const res = await fn(payload || {});
    return res.data;
  } catch (err) {
    throw wrapEhrServiceError(err, 'ehrGetConnectionStatus');
  }
}

export async function callEhrBeginConnect(payload) {
  try {
    const fn = functions.httpsCallable('ehrBeginConnect', { timeout: 120000 });
    const res = await fn(payload || {});
    return res.data;
  } catch (err) {
    throw wrapEhrServiceError(err, 'ehrBeginConnect');
  }
}

export async function callEhrDisconnect(payload) {
  try {
    const fn = functions.httpsCallable('ehrDisconnect');
    const res = await fn(payload || {});
    return res.data;
  } catch (err) {
    throw wrapEhrServiceError(err, 'ehrDisconnect');
  }
}

export async function callEhrFetchBundlePreview(payload) {
  try {
    const fn = functions.httpsCallable('ehrFetchBundlePreview', { timeout: 120000 });
    const res = await fn(payload || {});
    return res.data;
  } catch (err) {
    throw wrapEhrServiceError(err, 'ehrFetchBundlePreview');
  }
}

export async function callEhrFetchForWorkflow(payload) {
  try {
    const fn = functions.httpsCallable('ehrFetchForWorkflow', { timeout: 120000 });
    const res = await fn(payload || {});
    return res.data;
  } catch (err) {
    throw wrapEhrServiceError(err, 'ehrFetchForWorkflow');
  }
}
